interface AnimatorOptions {
    path: string;
    frames: number;

    $el: JQuery;
    $hover?: JQuery;
}

export default class Animator {
    private options: AnimatorOptions;

    private ctx: CanvasRenderingContext2D;
    private canvas: HTMLCanvasElement;
    private images: HTMLImageElement[];

    private frame: number;
    private lastframe: number;

    private toframe: number;
    private timer;

    public constructor(options: AnimatorOptions) {
        this.options = options;
        this.images = [];

        if (!this.options.$hover) {
            this.options.$hover = options.$el;
        }

        this.toframe = 0;
        this.frame = 0;
        this.lastframe = null;
        this.initHtml();
    }

    private drawFrame(frame: number): void {
        this.ctx.clearRect(0, 0, this.canvas.width, this.canvas.height);
        this.ctx.drawImage(this.images[frame], 0, 0);
    }

    private onFrame(): void {
        if (this.frame != this.lastframe) {
            this.drawFrame(this.frame);
        }

        if (this.toframe != this.frame) {
            window.requestAnimationFrame(() => {
                this.onFrame();
            });
        } else {
            this.stop();
        }
    }

    private stop(): void {
        if (this.timer != null) {
            clearInterval(this.timer);
            this.timer = null;
        }
    }

    private playToFrame(toframe: number): void {
        this.stop();
        this.toframe = toframe;

        window.requestAnimationFrame(() => {
            this.onFrame();
        });

        this.timer = setInterval(() => {
            if (this.frame == this.toframe) {
                this.stop();
            } else {
                const d = this.frame > this.toframe ? -1 : 1;
                this.frame += d;
            }
        }, 1000 / 15);
    }

    public initHtml(): void {
        this.load(() => {
            this.canvas = document.createElement('canvas');
            this.canvas.width = this.images[0].width;
            this.canvas.height = this.images[0].height;
            this.ctx = this.canvas.getContext('2d');

            // const $canvas = $(this.canvas);
            // $canvas.css({
            //     'max-width': this.canvas.width,
            //     'max-height': this.canvas.height,
            // });

            this.options.$el.append(this.canvas);

            this.drawFrame(0);

            this.options.$hover.hover(
                () => {
                    this.playToFrame(this.images.length - 1);
                },

                () => {
                    this.playToFrame(0);
                }
            );
        });
    }

    public load(onload: () => void): void {
        let loaded = 0;

        for (let i = 0; i < this.options.frames; i++) {
            const image = new Image();

            image.addEventListener('load', (e) => {
                loaded ++;

                if (loaded == this.options.frames) {
                    onload();
                }
            });

            image.src = this.options.path + '/' + i + '.png';

            this.images.push(image);
        }
    }
}
